export const getUserTimezone = (): string | undefined => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone || undefined;
  } catch {
    return undefined;
  }
};
